var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpublishEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4999 3.75004L1.49992 14.25L1.06982 13.6356L16.0698 3.13562L16.4999 3.75004Z",
    fill: "#A9B2B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4224 6.11986C15.5132 7.1663 16.1833 8.24471 16.4026 8.62503C16.5365 8.85708 16.5365 9.14297 16.4026 9.37503C15.7576 10.5 13.3501 14.145 9.20255 14.25H9.01505C7.3213 14.25 5.90539 13.6535 4.77664 12.8719L7.3692 11.0571C7.81708 11.4126 8.38376 11.625 9.00005 11.625C10.4498 11.625 11.6251 10.4498 11.6251 9.00003C11.6251 8.71048 11.5782 8.43188 11.4916 8.17141L14.4224 6.11986ZM13.8472 5.60697C12.589 4.56696 10.895 3.68689 8.79755 3.75003C4.65005 3.85503 2.25005 7.50003 1.59755 8.62503C1.46358 8.85708 1.46358 9.14297 1.59755 9.37503C1.85352 9.8179 2.7126 11.2116 4.14855 12.396L6.84937 10.5055C6.55047 10.0793 6.37505 9.56013 6.37505 9.00003C6.37505 7.55028 7.5503 6.37503 9.00005 6.37503C9.88968 6.37503 10.6759 6.81758 11.1507 7.49454L13.8472 5.60697ZM8.74289 10.0955C8.82548 10.1148 8.91157 10.125 9.00005 10.125C9.57622 10.125 10.0512 9.69189 10.1172 9.13347L8.74289 10.0955ZM9.92175 8.3548L8.07832 9.64521C7.95023 9.46254 7.87505 9.24006 7.87505 9.00003C7.87505 8.37871 8.37873 7.87503 9.00005 7.87503C9.38132 7.87503 9.71828 8.06468 9.92175 8.3548Z",
    fill: "#A9B2B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublishEye);
export default __webpack_public_path__ + "static/media/unpublishEye.303fc7c5c20142e882dccc3345d2f2cc.svg";
export { ForwardRef as ReactComponent };